import EventBus from './Event';
import { validators, onPhoneValueChange } from './utils/utils-form.js';

class ApplicantAgents {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$fieldHasAgent = this.$el.find('[name="agent_working_with_agent"]');
    this.$fieldAgentEmail = this.$el.find('[name="agent_email"]');
    this.$fieldAgentPhone = this.$el.find('[name="agent_phone"]');
    this.$fieldsGroup = this.$el.find('[data-agents-fields]');

    // this.$fieldAgentEmail.prop('disabled', true);
    // this.$fieldAgentPhone.prop('disabled', true);

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.onUserLoaded.bind(this));
    
    this.$fieldAgentPhone.on('input', (e) => onPhoneValueChange($(e.target)));
    this.$fieldHasAgent.on('change', this.onAgentChange.bind(this));
  }

  onUserLoaded() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    this.$el.find('[name="agent_owner_user"]').val(user.auth.email);
  }

  onAgentChange(e) {
    const $target = $(e.target);
    const value = $target.val();
    if (value === 'yes' || value === 'true') {
      this.$fieldAgentEmail.attr('required', 'required');
      this.$fieldsGroup.show();
    } else {
      this.$fieldAgentEmail.removeAttr('required');
      this.$fieldsGroup.hide();
    }
  }

  onSubmit() {
    // currently submits to firestore via webhook
    
    // @TODO: validate on submit
  }

  // @TODO: validate fields
  validateFields() {

  }

  static init() {
    $('[data-js-component="applicant-agents"]').each((i, el) => new ApplicantAgents(el));
  }
}

ApplicantAgents.init();
